import { createRouter, createWebHistory } from 'vue-router'
import Login from '../components/Login.vue'
import MainLayout from '../components/MainLayout.vue'
import Dashboard from '../components/Dashboard.vue'
import BookRoom from '../components/BookRoom.vue'
import BookCourse from '../components/CourseBooking.vue'
import Rooms from '../components/Rooms.vue'
import Courses from '../components/Courses.vue'
import Breaks from '../components/Breaks.vue'
import Users from '../components/UserManagement.vue'
import Reports from '../components/Reports.vue'
import StudySpace from '../components/StudySpace.vue'
import BookSpace from '../components/BookSpace.vue'
import CustodyHandover from '../components/CustodyHandover.vue'
import store from '../store'

const routes = [
  {
    path: '/',
    component: MainLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        redirect: '/dashboard'
      },
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: Dashboard,
        meta: { roles: ['admin', 'CEO', 'HR', 'Reception'] }
      },
      {
        path: 'book-room',
        name: 'BookRoom',
        component: BookRoom,
        meta: { roles: ['admin', 'CEO', 'HR', 'Reception'] }
      },
      {
        path: 'course-booking',
        name: 'CourseBooking',
        component: BookCourse,
        meta: { roles: ['admin', 'CEO', 'HR', 'Reception'] }
      },
      {
        path: 'rooms',
        name: 'Rooms',
        component: Rooms,
        meta: { roles: ['admin', 'CEO', 'HR'] }
      },
      {
        path: 'courses',
        name: 'Courses',
        component: Courses,
        meta: { roles: ['admin', 'CEO', 'HR'] }
      },
      {
        path: 'study-spaces',
        name: 'StudySpace',
        component: StudySpace,
        meta: { roles: ['admin', 'CEO', 'HR'] }
      },
      {
        path: 'book-space',
        name: 'BookSpace',
        component: BookSpace,
        meta: { requiresAuth: true }
      },
      {
        path: 'breaks',
        name: 'Breaks',
        component: Breaks,
        meta: { roles: ['admin', 'CEO', 'HR'] }
      },
      {
        path: 'users',
        name: 'Users',
        component: Users,
        meta: { roles: ['admin', 'CEO', 'HR'] }
      },
      {
        path: 'reports',
        name: 'Reports',
        component: Reports
      },
      {
        path: 'custody-handover',
        name: 'CustodyHandover',
        component: CustodyHandover,
        meta: { roles: ['admin', 'Reception'] }
      }
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { guest: true }
  },
  // Catch all route for 404
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  const isAuthenticated = store.getters['auth/isAuthenticated']
  
  // Check if route requires authentication
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!isAuthenticated) {
      // Redirect to login if not authenticated
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
      return
    } else {
      // Check role-based access
      const userRoles = store.getters['auth/userRoles']
      
      // Only check roles for the most specific matched route (the last one)
      const matchedRoute = to.matched[to.matched.length - 1]
      const requiredRoles = matchedRoute.meta?.roles
      
      if (requiredRoles && requiredRoles.length > 0) {
        // Check if user has any of the required roles
        const hasRequiredRole = userRoles.some(role => requiredRoles.includes(role))
        
        console.log(`Route ${to.path} requires roles:`, requiredRoles)
        console.log(`User has roles:`, userRoles)
        console.log(`Has required role:`, hasRequiredRole)
        
        if (!hasRequiredRole) {
          // If user doesn't have required role, redirect to a fallback route
          // Only redirect if we're not already on the dashboard to avoid loops
          if (to.path !== '/dashboard') {
            console.log(`Redirecting to dashboard due to insufficient permissions`)
            next({ path: '/dashboard' })
            return
          } else {
            // If we're already on dashboard and don't have access, just proceed
            // This prevents infinite loops
            next()
            return
          }
        }
      }
      
      // User is authenticated and has required roles (or no roles required)
      next()
    }
  } else if (to.matched.some(record => record.meta.guest)) {
    if (isAuthenticated) {
      // Redirect to dashboard if already authenticated
      next({ path: '/dashboard' })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
